import React, { useRef } from 'react';
import styles from './styles.module.scss';
import { Hero3DRenderer } from './threeSetup';
import classnames from 'classnames';

const HeroPlaceholder = ({
  className,
  src,
  onCompleted,
  scaleRatio = 1,
  disableHint
}) => {
  const containerRef = useRef(null);
  React.useLayoutEffect(() => {
    async function checkLoad(renderer) {
      const isReady = await renderer.isReady;

      if (isReady) {
        onCompleted();
      }
    }

    if (!containerRef.current) return undefined;
    const renderer = new Hero3DRenderer(src);
    renderer.mountRenderer(containerRef.current);
    renderer.render(scaleRatio);
    checkLoad(renderer);
    return renderer.destroy;
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.container, className),
    ref: containerRef,
    onMouseDown: disableHint,
    onTouchStart: disableHint
  });
};

export default HeroPlaceholder;